import { Col, Row, Skeleton } from 'ui';

const PasskeySkeleton = () => (
  <Row align="middle" justify="space-between">
    <Col span={20}>
      <Skeleton active paragraph={{ rows: 4 }} title={{ width: 120 }} />
    </Col>
    <Col span={4}>
      <Skeleton.Button active shape="circle" size="small" />
    </Col>
  </Row>
);

export default PasskeySkeleton;
